<p>modify-product-master-group works!</p>
